import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router';
import MySettings from '../../../auth/containers/MySettings';

import OrganisationSettings from '../../../auth/containers/OrganisationSettings';
import InternalNavigation from '../InternalNavigation/InternalNavigation';
import logo from '../../../../images/brand/jlogo.png';
import MdExitToApp from 'react-icons/lib/md/exit-to-app';
import { hasPermission, isBroker, logOut } from '../../../auth/redux/authActions';
import QuickSearch from '../../../dashboard/components/QuickSearch';
import Icon from '../../../../common/components/Icon/Icon';
import { Avatar } from '../../../../common/components';
import './InternalHeader.scss';
import getIncludedResource from '../../../../helpers/getIncludedResource';

export default class InternalHeader extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    layout: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      mobileDropdown: false,
    };
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleLogout(e) {
    e.preventDefault();
    this.props.dispatch(logOut());
  }

  componentWillMount() {}

  render() {
    const { auth } = this.props;
    const currentOrganisationName = (user) => {
      const organisation = getIncludedResource(
        user.data,
        user.included,
        'current_organisation',
      );
      return organisation.data.attributes ? organisation.data.attributes.name : '';
    };
    const currentBrokerName = (user) => {
      const broker = getIncludedResource(user.data, user.included, 'current_broker');
      return broker.data.attributes ? broker.data.attributes.name : '';
    };
    return (
      <header className="header">
        <div className="navbar">
          <Link to="/dashboard" onlyActiveOnIndex>
            <img alt="logo" className="logo" src={logo} />
          </Link>
          {hasPermission('search.quick') && (
            <div className="search-tab item1 quicksearch-text">
              <p>
                {' '}
                Quick&nbsp;Search{' '}
              </p>
              <QuickSearch />
            </div>
          )}
          <div className="user-avatar">
            <Avatar user={auth.user} />
          </div>

          <div className="container-info-logout">
            <div className="user-info">
              <span className="name-info">
                {auth.user.data.attributes.first_name +
                  ' ' +
                  auth.user.data.attributes.last_name}
              </span>
              <br />
              <span className="organisation-info">
                {isBroker()
                  ? currentBrokerName(auth.user)
                  : currentOrganisationName(auth.user)}
              </span>
              <br />
              <div className="date-info-container">
                <div className="date">
                  {' '}
                  {new Date().getUTCDate()} / {new Date().getMonth() + 1} /{' '}
                  {new Date().getUTCFullYear()}{' '}
                </div>
                <div className="user-logout" onClick={this.handleLogout}>
                  <div>
                    <MdExitToApp size={20} />
                  </div>
                  <div className="logout-title">Log Out</div>
                </div>
              </div>
            </div>
          </div>
          <div className="burgerMenu">
            <Button
              className="burgerMenuBt"
              onClick={() =>
                this.setState({ mobileDropdown: !this.state.mobileDropdown })
              }
            >
              <Icon name="bars" />
            </Button>
            <div className="dropmenu mobile-dropdown-menu-box">
              {this.state.mobileDropdown && (
                <div>
                  <InternalNavigation {...this.props} />
                  <div className="divider" />
                  <span className="logout-bt-mobile" onClick={this.handleLogout}>
                    <Icon name="sign-out" />
                    Logout
                  </span>
                  <span
                    className="close-area-mobile-menu"
                    onClick={() =>
                      this.setState({ mobileDropdown: !this.state.mobileDropdown })
                    }
                  />
                </div>
              )}
            </div>
            <MySettings {...this.props} />
            <OrganisationSettings {...this.props} />
          </div>
        </div>
      </header>
    );
  }
}
